import ProductTileBase from 'org/components/search/ProductTile';

export default class ProductTile extends ProductTileBase {
    init() {
        if (this.eligibleOnDevice()) {
            this.settings = {
                mainImage: '.js-tile-carousel_image',
                swatchesWrapper: '.js-tile-swatches',
                swatchSelector: '.js-swatch-link',
                promoSelector: '.b-product_promo',
                newBadgeSelector: '.new-badge-selection'
            };
            this.rolloverDelay = 100; // ms
            this.rolloverToken = null;

            this.initConfig(this.settings);
            this.initializeCache();
            this.initializeEvents();

            this.cache.$promotionCallout = $(this.config.promoSelector, this.$el);
            this.cache.$defaultPromotionCallout = this.cache.$promotionCallout.html();
            this.eventDelegate('mouseenter', this.settings.swatchSelector, this.changePromotionCallout.bind(this), this.cache.$swatchesWrapper);

            this.cache.$newBadge = $(this.config.newBadgeSelector, this.$el);
            this.cache.$defaultBadgeCallout = this.cache.$newBadge.html();
            this.eventDelegate('mouseenter', this.settings.swatchSelector, this.applyNewBadge.bind(this), this.cache.$swatchesWrapper);
        }
    }

    changePromotionCallout(event) {
        const $promoCallout = $(event.currentTarget).data('promo-callout');
        const $promoCalloutElement = this.cache.$promotionCallout;

        if (!$promoCallout) {
            return;
        }
        const { inclusionPromotions = [] } = $promoCallout;
        let html = '';

        inclusionPromotions.forEach((promotion) => {
            html += `<div class="b-promo-tooltip-content ${promotion.calloutMsg && promotion.calloutMsg === '' ? 'hide' : ''}">
                <span class="hide-mobile">
                    <span class="b-promo-tooltip-content-text">
                        ${promotion.calloutMsg}
                    </span>
                    <span class="g-tooltip-icon g-tooltip bfx-remove-element ${promotion.details ? '' : 'hide'}">
                        <span class="g-tooltip-text">
                            ${promotion.details}
                        </span>
                    </span>
                  </span>
                 <span class="hide-desktop">
                     <span class="b-promo-tooltip-content-text">
                          ${promotion.calloutMsg}
                     </span>
                     <span class="${promotion.details ? '' : 'hide'}">
                         <span class="g-tooltip-icon g-tooltip bfx-remove-element">
                             <span class="g-tooltip-arrow"></span>
                         </span>
                         <span class="g-tooltip-text">
                             ${promotion.details}
                         </span>
                     </span>
                </span>
             </div>`;
        });

        // Remove only "Inclusion" promotion callouts
        $promoCalloutElement.find('.b-promo-tooltip-content').not('.b-not-eligible').remove();
        // Add the new promotion content at the beginning of $promoCalloutElement,
        // ensuring that "Exclusion" messaging (b-not-eligible) remains unaffected
        $promoCalloutElement.prepend(html);

        // Refresh the OWL carousel present on the Homepage to adjust the promo callout display
        if ($promoCalloutElement.closest('.owl-carousel').length) {
            $promoCalloutElement.closest('.owl-carousel').trigger('refresh.owl.carousel');
        }
    }

    applyNewBadge(event) {
        let $earlyAccessbadge = $(event.currentTarget).data('early-access-badge');
        let $experienceType = $(event.currentTarget).data('experience-type');
        let $newBadgeCallout = $(event.currentTarget).data('new-badge');
        let $flameIconUrl = $(event.currentTarget).data('flame-icon-url');

        let $flameIcon = this.cache.$newBadge.find('.b-flameIcon');
        let $eaBadge = this.cache.$newBadge.find('.b-EarlyAccess-Icon');

        // Remove only if not needed to avoid flickering
        if ($newBadgeCallout === null || $earlyAccessbadge !== null || $experienceType) {
            $flameIcon.remove();
        }
        if ($earlyAccessbadge === null) {
            $eaBadge.remove();
        }

        // Insert the Flame Icon only if not present
        if ($newBadgeCallout !== null && $earlyAccessbadge == null && !$experienceType) {
            if (!$flameIcon.length) {
                const badgeContent = `
                    <div class="b-tile-badge_top_left b-flameIcon">
                        <span class="b-flameIcon-sec">
                            <img class="img-flameIcon" src="${$flameIconUrl}" alt="Promo Badge"/>
                            <span class="flameIcon-text">${$newBadgeCallout || ''}</span>
                        </span>
                    </div>`;
                this.cache.$newBadge.append(badgeContent);
            }
        }

        // Update or insert the Early Access Badge
        if ($earlyAccessbadge !== null) {
            if ($eaBadge.length) {
                $eaBadge.find('.ea-Icon-Text').text($earlyAccessbadge || '');
            } else {
                const eaBadgeContent = `
                    <div class="b-tile-badge_top_left tile-EA-Badge-Top-Left b-EarlyAccess-Icon">
                        <span class="b-EA-Icon-sec">
                            <span class="ea-Icon-Text">${$earlyAccessbadge || ''}</span>
                        </span>
                    </div>`;
                this.cache.$newBadge.append(eaBadgeContent);
            }
        }
    }

    changeToDefault() {
        const $promoCalloutElement = this.cache.$promotionCallout;

        super.changeToDefault();

        const currentBadgeHtml = this.cache.$newBadge.html().trim();
        const defaultBadgeHtml = this.cache.$defaultBadgeCallout.trim();

        if (currentBadgeHtml !== defaultBadgeHtml) {
            this.cache.$newBadge.html(this.cache.$defaultBadgeCallout);
        }

        $promoCalloutElement.html(this.cache.$defaultPromotionCallout);

        // Refresh the OWL carousel present on the Homepage to adjust the promo callout display
        if ($promoCalloutElement.closest('.owl-carousel').length) {
            $promoCalloutElement.closest('.owl-carousel').trigger('refresh.owl.carousel');
        }
    }
}
